import React, { useState } from 'react';

import './CertificateInfo.css';
import HeaderInsideFooter from './HeaderInsideFooter';
import Diploma from '../../../diploma/Diploma';

const certificateQuestions = [
  {
    id: 2,
    question: 'Cum obtin o certificare ContaLearn?',
    answer:
      'Finalizeaza un curs eligibil pe ContaLearn. Dupa finalizare, certificatul este emis automat si devine disponibil in contul tau.',
  },
  {
    id: 3,
    question: 'De ce este util un certificat ContaLearn?',
    answer:
      'Certificatul poate sustine prezentarea progresului tau educational si ofera o metoda simpla prin care o alta persoana poate verifica autenticitatea documentului.',
  },
  {
    id: 4,
    question: 'Cum poate fi verificat?',
    answer:
      'Fiecare certificat primeste un cod unic si un cod QR. Scanarea codului QR deschide pagina publica de verificare a certificatului.',
  },
  {
    id: 5,
    question: 'Poate fi distribuit pe LinkedIn?',
    answer:
      'Da. Certificatul poate fi descarcat in format PDF, iar linkul public de verificare poate fi distribuit pe LinkedIn sau pe alte platforme.',
  },
];

const CertificateInfo = () => {

  const [openQuestion, setOpenQuestion] = useState(null);

  return (

    <div className="certificate-info-page">

  


      <div className="certificate-info-layout">


        {/* =========================
            STANGA
        ========================= */}

        <div className="certificate-info-left">


          <div className="certificate-info-intro">

           

            <h1 className="certificate-info-title">
              Demonstreaza-ti progresul printr-un certificat verificabil
            </h1>

            <p className="certificate-info-description">
              La finalizarea unui curs eligibil, ContaLearn iti ofera
              un certificat digital care confirma finalizarea cursului
              si poate fi verificat online printr-un cod unic.
            </p>

          </div>


{/* INTREBARI DESPRE CERTIFICAT */}

<div className="certificate-faq">

{certificateQuestions.map((item) => (

    <section
      key={item.id}
      className={`certificate-faq-item ${
        openQuestion === item.id ? "is-open" : ""
      }`}
    >

      <button
        type="button"
        className="certificate-faq-question"
        aria-expanded={openQuestion === item.id}
        aria-controls={`certificate-answer-${item.id}`}
        onClick={() =>
          setOpenQuestion(
            openQuestion === item.id ? null : item.id
          )
        }
      >

        <span>{item.question}</span>

        <span className="certificate-faq-arrow">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </span>

      </button>

      <div
        id={`certificate-answer-${item.id}`}
        className="certificate-faq-answer"
        hidden={openQuestion !== item.id}
      >
        <p>{item.answer}</p>
      </div>

    </section>

  ))}

</div>



        </div>


        {/* =========================
            DREAPTA
        ========================= */}

        <div className="certificate-info-right">


          <section className="certificate-info-preview-section">

            <div className="certificate-info-section-header">

           

          

            </div>


            <div className="certificate-info-preview-wrapper">

              <Diploma
                previewUser={{
                  id: 'DEMO-2026-001',
                  username: 'Andrei Popescu'
                }}
                previewMode
              />

            </div>

          </section>


        </div>


      </div>

    </div>

  );

};


export default CertificateInfo;